<template>
  <v-snackbar
    app
    :color="webTheme.colors.primary.hexa"
    :value="$t(snackbar)"
    top
  >
    {{ $t(snackbar) }}
  </v-snackbar>
</template>

<script>
export default {
  data: () => ({}),
  computed: {
    snackbar() {
      return this.$store.state.snackbar;
    },
    webTheme() {
      const currentProgram = this.$store.getters.currentProgram;
      return (
        currentProgram?.webTheme || { colors: { primary: { hexa: "#e91e63" } } }
      );
    }
  },
  watch: {
    snackbar(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.$store.dispatch("setSnackbar", null);
        }, 5000);
      }
    }
  }
};
</script>
